export class FiltroFaturamentoPorTipoAcao {
  AnoSelecionado: string;
  TipoDeAcaoId: number;
  ListaDesconsiderarDR: number[];

  constructor() {
    let anoAtual: string = (new Date()).getFullYear().toString();
    this.AnoSelecionado = anoAtual;
    this.TipoDeAcaoId = 0;
    this.ListaDesconsiderarDR = [];
  }
}
